import { render, staticRenderFns } from "./system_set.vue?vue&type=template&id=6d009b0a&scoped=true"
import script from "./system_set.vue?vue&type=script&lang=js"
export * from "./system_set.vue?vue&type=script&lang=js"
import style0 from "./system_set.vue?vue&type=style&index=0&id=6d009b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d009b0a",
  null
  
)

export default component.exports